// extracted by mini-css-extract-plugin
export default {"product":"GdFsr","image":"M68AI","name":"ZqRL9","desc":"b7lIP"};